import Tooltip from './Tooltip'

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js